/**
 * Theme-wide campaign order tagging (v2).
 *
 * Ensures every cart carries a `_campaign` attribute, which the
 * "Assign campaign tag to order" Shopify Flow turns into an order tag
 * ("Campaign: <value>").
 *
 * Write rules, in order:
 *   - `_campaign` empty            -> write this theme's tag
 *   - value is another THEME-level tag (REPLACEABLE) -> overwrite: the
 *     visitor is being served THIS theme now, so a theme-level tag left
 *     over from a previous visit (e.g. the other arm of an AB rollout)
 *     is stale attribution
 *   - anything else (page-specific tags like "Snap"/"Week 4 Page 1",
 *     ?campaign= URL tags)        -> keep; those fire at add-to-cart time
 *     and are more specific than the theme default
 *
 * Retries cover the first-pageview race: pixels (e.g. Triple Whale) may
 * create the cart concurrently and win the cart-cookie write, dropping
 * the attribute we just set. Re-running is idempotent under the rules
 * above.
 *
 * Known gap: dynamic checkout buttons (Buy it now / Shop Pay / PayPal)
 * skip the cart entirely, so those orders cannot be tagged from the theme.
 */
(function () {
  var config = window.CampaignTagSync;
  if (!config || !config.campaign) return;

  // Theme-level tags any theme may reclaim. Page-specific tags are never listed here.
  var REPLACEABLE = [
    'main-bundle-offers',
    'KK21',
    'KK21V2',
    'KK16V1',
    'KK16V2',
    'RONKK2-bundle-offers',
  ];

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sync() {
    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var current = cart && cart.attributes && cart.attributes._campaign;
        if (current === config.campaign) return;
        if (current && REPLACEABLE.indexOf(current) === -1) return;

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _campaign: config.campaign } }),
        });
      })
      .catch(function () {
        /* Tagging is best-effort — never break the storefront over it. */
      });
  }

  sync();
  setTimeout(sync, 4000);
  setTimeout(sync, 15000);
})();
